module.exports = __webpack_public_path__ + "img/12600.44726f1d.jpg";